module.exports = __webpack_public_path__ + "img/99f94f1bf14b3fc504bcd836be0d016d.ffbb098e.jpg";